import { useMemo } from "react";

import { PatientInsurance } from "pwapi";

const useInsurance = (insurances?: PatientInsurance[]) => {
  return useMemo(
    () => ({
      primary: insurances?.find((insur) => insur.primary_provider),
      additional: insurances?.filter((insur) => !insur.primary_provider) || [],
    }),
    [insurances]
  );
};

export default useInsurance;
